import cx from 'classnames';
import React from 'react';
import Rating from '../FeedbackRating';
import HTMLContent from '../HTMLContent';
import Title from './Title';
import { appendClassSuffix } from './utils';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CampusBody = function CampusBody(_ref) {
  var body = _ref.body,
      title = _ref.title;
  return ___EmotionJSX("div", {
    className: "dc-sct-feedback__campus-content"
  }, ___EmotionJSX(Title, {
    title: title
  }), ___EmotionJSX(HTMLContent, {
    className: "dc-sct-feedback__text",
    html: body,
    mathJaxEnabled: true
  }));
};

var Body = function Body(_ref2) {
  var body = _ref2.body,
      children = _ref2.children,
      isActive = _ref2.isActive,
      messageType = _ref2.messageType,
      rating = _ref2.rating,
      title = _ref2.title;
  if (!isActive) return null;
  return ___EmotionJSX("div", {
    className: cx('dc-sct-feedback__body', appendClassSuffix('dc-sct-feedback__body', messageType))
  }, ___EmotionJSX("div", {
    className: "dc-sct-feedback__content"
  }, children, title && body && ___EmotionJSX(CampusBody, {
    body: body,
    title: title
  })), rating && ___EmotionJSX(Rating, rating));
};

export default Body;